import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import {
  SelectionTagsListDefinition,
  SelectionTagsListProps,
  SelectionTagsListCSSVars,
  SelectionTagsListCssCarmiData,
  SelectionTagsListAlignmentProps,
} from '../SelectionTagsList.types';

export const props = withCompInfo<
  SelectionTagsListProps,
  SelectionTagsListDefinition
>()(['compData', 'compProps'], ({ compData, compProps }) => {
  const { isDisabled, required } = compProps;
  const { options, value } = compData;

  return { options, value, isDisabled, required };
});

export const css = withCompInfo<
  SelectionTagsListCSSVars,
  SelectionTagsListDefinition,
  SelectionTagsListCssCarmiData
>()(['compProps', 'compLayout'], ({ compProps, compLayout }, carmiProps) => {
  const { direction } = compProps;

  let alignment = '' as SelectionTagsListAlignmentProps;

  if (compProps.alignment === 'left') {
    if (direction === 'rtl') {
      alignment = 'flex-end';
    } else {
      alignment = 'flex-start';
    }
  } else if (compProps.alignment === 'right') {
    if (direction === 'rtl') {
      alignment = 'flex-start';
    } else {
      alignment = 'flex-end';
    }
  } else {
    alignment = compProps.alignment;
  }

  return {
    height: 'auto',
    'min-height': compLayout.height || 0,
    '--direction': direction,
    '--alignment': alignment,
    '--fnt': carmiProps['--fnt'],
  };
});

export default createComponentMapperModel({ props, css: css as any });
